module.exports = __webpack_public_path__ + "static/media/Bothivehosting.d3250a4e.png";